import { useMemo } from 'react';
import jwtDecode, { type JwtDecodeOptions } from 'jwt-decode';

export const useJwtTokenPayload = <T = unknown>(
	token: string,
	options?: JwtDecodeOptions
): T | undefined =>
	useMemo(() => {
		try {
			return jwtDecode<T>(token, options);
		} catch (parsingError) {
			console.error(`Cannot parse JWT token:`, parsingError.message);
			return undefined;
		}
	}, [options, token]);
